import React from "react";
import { SafeAreaView, KeyboardAvoidingView, Platform } from "react-native";
import Box from "../Box";
import Stack from "../Stack";
import Typography from "../Typography";
import Button from "../OldButton";
// import Icon from "../Icon";

interface PropTypes {
  children: React.ReactNode;
  title?: string;
  back?: () => void;
  dismiss?: () => void;
}

function Modal(props: PropTypes) {
  let { title, back, dismiss } = props;
  let hasTitleBar = title || back || dismiss;
  // let distribution = "space-between";
  // if (!dismiss && back) {
  //   distribution = "start";
  // }

  return (
    <Box
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "absolute",
        bottom: 0,
        left: 0,
        flex: 1,
        width: "100%",
        height: "100%",
        justifyContent: "flex-end",
      }}
    >
      {/* <Box
        bg="common.white"
        style={{
          // backgroundColor: "#fff",
          borderTopRightRadius: 12,
          borderTopLeftRadius: 12,
        }}
      > */}
      <KeyboardAvoidingView
        behavior={Platform.OS == "ios" ? "padding" : "height"}
      >
        <SafeAreaView
          style={{
            backgroundColor: "#fff",
            borderTopRightRadius: 12,
            borderTopLeftRadius: 12,
          }}
        >
          {hasTitleBar && (
            <Stack p="m" distribution="space-between">
              <Box>
                {back && (
                  <Button onPress={back} size="s">
                    {/* <Icon name="arrow-right" size={24} color="secondary.main" /> */}
                    <Typography>بازگشت</Typography>
                  </Button>
                )}
              </Box>
              {title && <Typography ff="mainBold">{title}</Typography>}
              <Box>
                {dismiss && (
                  <Button onPress={dismiss} size="s">
                    {/* <Icon name="x" size={24} color="secondary.main" /> */}
                    <Typography>بستن</Typography>
                  </Button>
                )}
              </Box>
            </Stack>
          )}
          <Box p="l">{props.children}</Box>
        </SafeAreaView>
      </KeyboardAvoidingView>
      {/* </Box> */}
    </Box>
  );
}

export default Modal;
